import classNames from 'classnames';

import IconHelp from '../IconHelp/IconHelp';
import Popover from '../Popover/Popover';

import css from './HelpTooltip.module.css';

const HelpTooltip = ({ className, iconClassName, align, children }) => (
  <Popover
    triggerClassName={classNames(css.trigger, className)}
    contentClassName={css.content}
    contentComponent={children}
    contentAlign={align}
  >
    <IconHelp className={classNames(css.icon, iconClassName)} />
  </Popover>
);

export default HelpTooltip;
